import React, { useEffect, useState } from 'react';
import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilRefresh from '@iconscout/react-unicons/icons/uil-refresh';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import UilUser from '@iconscout/react-unicons/icons/uil-user';
import { Avatar } from 'antd';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import Heading from '../../heading/heading';
import { Popover } from '../../popup/popup';
import { useAuth } from '../../../hooks/useAuth';
import { useGirisYapilacakUserList } from '../../../hooks/useGirisYapilacakUserList';

import { KURUM, FIRMA, MUHENDIS, ADMIN as ADMINTYPE } from '../../../constants/typeConstant';
import {
  JEOLOJI_VE_JEOFIZIK_MUHENDISI,
  JEOFIZIK_MUHENDISI,
  JEOLOJI_MUHENDISI,
  SUBE_MUDURU,
  BAKANLIK_DAIRE_BASKANI,
  GENEL_MUDUR_YARDIMCISI,
  GENEL_MUDUR,
  IL_MUDUR_YARDIMCISI,
  IL_MUDURU,
  IL_SUBE_MUDURU,
  KAMU_MUHENDISI,
  UYGULAMA_YONETICISI,
  KOMISYON,
  KOMISYON_UYESI,
  KOMISYON_YEDEK_UYESI,
  DUYURU_YETKILISI,
  FIRMA_ONAY_YETKILI,
  PROJE_ALANI_KILITLEME_YETKILI,
  PROJE_DURUMU_DEGISTIRME,
  KURUM_KULLANICI_DUZENLEME_YETKILI,
  ILLER_BANKASI,
  ILBANK,
  IL_MUHENDISI,
  MUHENDIS as MUHENDISROLE,
} from '../../../constants/roleConstant';
import { DataService } from '../../../config/dataService/dataService_yerbis';
import NotificationHelper from '../../../utility/notificationHelper';
import { t, use } from 'i18next';
import { useSelector } from 'react-redux';
import HomeFilled from '@ant-design/icons/lib/icons/HomeFilled';

import CokluUserGirisYap from './CokluUserGirisYap';

const AuthInfo = React.memo(() => {
  const { user, logout, isUserAuthenticated, userDetail } = useAuth();
  const { userList, kulDegistir } = useGirisYapilacakUserList();

  const [multiUser, setMultiUser] = useState(false);
  const [muhendisData, setMuhendisData] = useState({});
  const [firmaData, setFirmaData] = useState({});
  const [kurumData, setKurumData] = useState({});
  const { updateTrigger } = useSelector((state) => state.muhendis);
  const [state, setState] = useState({
    flag: 'tr',
  });
  const navigate = useNavigate();

  const baseUrl = `${process.env.REACT_APP_YERBIS_TEST_APP_API_ENDPOINT}`;

  const getMuhendisData = async () => {
    try {
      const response = await DataService.post(`${process.env.REACT_APP_MUHENDIS_BILGI_ENDPOINT}`, {
        muhendisIdStr: user.muhendisIdHash,
      });
      setMuhendisData({ ...response.data.model });
    } catch (err) {
      NotificationHelper.setErrorNotification();
    } finally {
      //
    }
  };

  const getFirmaData = async () => {
    try {
      const response = await DataService.post('/Api/List/FirmaGetByid', {
        firmaId: user.userNameHashStr,
      });

      setFirmaData({ ...response.data.model[0] });
    } catch (err) {
      NotificationHelper.setErrorNotification();
    } finally {
      //
    }
  };

  const getKurumData = async () => {
    try {
      const response = await DataService.post('/Api/List/KurumGetByid', {
        firmaId: user.userNameHashStr,
      });

      setKurumData({ ...response.data.model[0] });
    } catch (err) {
      NotificationHelper.setErrorNotification();
    } finally {
      //
    }
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  useEffect(() => {
    if (userDetail) {
      setMuhendisData({});
      setFirmaData({});
      setKurumData({});
      return;
    }
    switch (user.type) {
      case KURUM:
        getKurumData();
        break;
      case FIRMA:
        getFirmaData();
        break;
      case MUHENDIS:
        getMuhendisData();
        break;
      case ADMINTYPE:
        getMuhendisData();
        break;
      default:
        break;
    }
  }, [user, updateTrigger, userDetail]);

  let profileUrl = '';
  switch (user.type) {
    case KURUM:
      profileUrl = `/admin/BilgiSayfalari/KurumBilgileri/KurumDetay/${user.userNameHashStr}`;
      break;
    case FIRMA:
      profileUrl = `/admin/BilgiSayfalari/FirmaBilgileri/FirmaDetay/${user.userNameHashStr}`;
      break;
    case MUHENDIS:
      profileUrl = `/admin/BilgiSayfalari/MuhendisBilgileri/MuhendisDetay/${user.muhendisIdHash}`;
      break;
    case ADMINTYPE:
      profileUrl = `/admin/BilgiSayfalari/MuhendisBilgileri/MuhendisDetay/${user.muhendisIdHash}`;
      break;
    default:
      break;
  }

  let changePasswordUrl = '';
  switch (user.type) {
    case KURUM:
      changePasswordUrl = `/admin/BilgiSayfalari/KurumBilgileri/SifreDegistir/${user.userNameHashStr}`;
      break;
    case FIRMA:
      changePasswordUrl = `/admin/BilgiSayfalari/FirmaBilgileri/SifreDegistir/${user.userNameHashStr}`;
      break;
    case MUHENDIS:
      changePasswordUrl = `/admin/BilgiSayfalari/MuhendisBilgileri/SifreDegistir/${user.muhendisIdHash}`;
      break;
    case ADMINTYPE:
      changePasswordUrl = `/admin/BilgiSayfalari/MuhendisBilgileri/SifreDegistir/${user.muhendisIdHash}`;
      break;
    default:
      break;
  }

  const roles = {
    [GENEL_MUDUR]: 1,
    [GENEL_MUDUR_YARDIMCISI]: 2,
    [BAKANLIK_DAIRE_BASKANI]: 3,
    [IL_MUDURU]: 4,
    [IL_MUDUR_YARDIMCISI]: 5,
    [SUBE_MUDURU]: 6,
    [JEOLOJI_MUHENDISI]: 7,
    [JEOFIZIK_MUHENDISI]: 8,
    [JEOLOJI_VE_JEOFIZIK_MUHENDISI]: 9,
  };

  const rolePriority = {
    [GENEL_MUDUR]: 1,
    [GENEL_MUDUR_YARDIMCISI]: 2,
    [BAKANLIK_DAIRE_BASKANI]: 3,
    [IL_MUDURU]: 4,
    [IL_MUDUR_YARDIMCISI]: 5,
    [SUBE_MUDURU]: 6,
    [JEOLOJI_MUHENDISI]: 7,
    [JEOFIZIK_MUHENDISI]: 8,
    [JEOLOJI_VE_JEOFIZIK_MUHENDISI]: 9,
    [IL_SUBE_MUDURU]: 10,
    [KAMU_MUHENDISI]: 11,
    [FIRMA]: 12,
    [UYGULAMA_YONETICISI]: 13,
    [KOMISYON]: 14,
    [KOMISYON_UYESI]: 15,
    [KOMISYON_YEDEK_UYESI]: 16,
    [DUYURU_YETKILISI]: 17,
    [FIRMA_ONAY_YETKILI]: 18,
    [PROJE_ALANI_KILITLEME_YETKILI]: 19,
    [KURUM_KULLANICI_DUZENLEME_YETKILI]: 20,
    [PROJE_DURUMU_DEGISTIRME]: 21,
    [ILLER_BANKASI]: 22,
    [ILBANK]: 23,
    [IL_MUHENDISI]: 24,
    [MUHENDISROLE]: 25,
  };

  let highestRole = '';

  user.userGroups.forEach((g) => {
    const groupId = g.userGroupId;

    if (roles[groupId] && (!highestRole || rolePriority[groupId] < rolePriority[highestRole])) {
      highestRole = groupId;
    }
  });

  if (!highestRole) {
    highestRole = t('diger'); // Diğer olarak belirliyoruz
  }

  switch (highestRole) {
    case GENEL_MUDUR:
      highestRole = t('genelMudur');
      break;
    case GENEL_MUDUR_YARDIMCISI:
      highestRole = t('genelMudurYrd');
      break;
    case BAKANLIK_DAIRE_BASKANI:
      highestRole = t('daireBaskani');
      break;
    case IL_MUDURU:
      highestRole = t('ilMudur');
      break;
    case IL_MUDUR_YARDIMCISI:
      highestRole = t('ilMudurYrd');
      break;
    case SUBE_MUDURU:
      highestRole = t('subeMuduru');
      break;
    case JEOLOJI_VE_JEOFIZIK_MUHENDISI:
      highestRole = t('jeolojivejeofizikMuh');
      break;
    case JEOLOJI_MUHENDISI:
      highestRole = t('jeolojiMuh');
      break;
    case JEOFIZIK_MUHENDISI:
      highestRole = t('jeofizikMuh');
      break;
    default:
      break;
  }

  let profileFullUserName = '';
  let profileUserName = '';
  switch (user.type) {
    case KURUM:
      profileFullUserName = user.name ? user.name : kurumData.FirmaAdi ?? '';
      profileUserName = truncateText(`${user.name ? user.name : kurumData.FirmaAdi ?? ''}`);
      break;
    case FIRMA:
      profileFullUserName = firmaData.FirmaAdi ?? '';
      profileUserName = truncateText(`${firmaData.FirmaAdi ?? ''}`);
      break;
    case MUHENDIS:
      profileFullUserName = `${muhendisData.UnvanName ?? ''} ${muhendisData.Ad ?? ''} ${muhendisData.Soyad ?? ''} - ${
        highestRole ?? ''
      }`;
      profileUserName = truncateText(
        `${muhendisData.UnvanName ?? ''} ${muhendisData.Ad ?? ''} ${muhendisData.Soyad ?? ''} - ${highestRole ?? ''}`,
      );
      break;
    case ADMINTYPE:
      profileFullUserName = `${user.name ?? ''} ${user.surname ?? ''}`;
      profileUserName = truncateText(`${user.name ?? ''} ${user.surname ?? ''}`);
      break;
    default:
      profileFullUserName = `${user.name ?? ''} ${user.surname ?? ''}`;
      profileUserName = truncateText(`${user.name ?? ''} ${user.surname ?? ''}`);
      break;
  }

  let profilePhoto = '';
  switch (user.type) {
    case KURUM:
      profilePhoto = kurumData.Logo ?? '';
      break;
    case FIRMA:
      profilePhoto = firmaData.Logo ?? '';
      break;
    case MUHENDIS:
      profilePhoto = muhendisData.ReservedPicture ?? '';
      break;
    case ADMINTYPE:
      profilePhoto = muhendisData.ReservedPicture ?? '';
      break;
    default:
      profilePhoto = `${user.name ?? ''} ${user.surname ?? ''}`;
      break;
  }

  const { flag } = state;

  const SignOut = (e) => {
    e.preventDefault();
    logout(() => navigate('/'));
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info  align-items-center" style={{ display: 'flex', alignItems: 'center' }}>
          {profilePhoto === '' ? (
            <Avatar style={{ marginRight: 18 }} icon={<UilUser />} />
          ) : (
            <img
              style={{
                width: '40px',
                height: '40px',
                objectFit: 'contain',
              }}
              src={`${baseUrl}${profilePhoto}`}
              alt=""
            />
          )}

          <figcaption>
            {user.type === 2 ? (
              <Heading as="h5">{`${muhendisData.UnvanName ?? ''} ${muhendisData?.Ad ?? ''} ${
                muhendisData?.Soyad ?? ''
              }`}</Heading>
            ) : user.type === 1 ? (
              <Heading as="h5">{firmaData?.FirmaAdi}</Heading>
            ) : user.type === 0 ? (
              <Heading as="h5">{user.name ? user.name : kurumData?.FirmaAdi}</Heading>
            ) : (
              <Heading as="h5">{`${user.name} ${user.surname}`}</Heading>
            )}
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Link to={profileUrl}>
              <UilUser /> {t('info.profile')}
            </Link>
          </li>
          {kulDegistir && (
            <li>
              <Link
                to="#"
                onClick={() => {
                  setMultiUser(true);
                }}
              >
                <UilRefresh /> {t('info.kulDegistir')}
              </Link>
            </li>
          )}

          {/* <li>
            <Link to={changePasswordUrl}>
              <UisKeySkeleton /> {t('info.changePassword')}
            </Link>
          </li> */}
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <UilSignout /> {t('info.signOut')}
        </Link>
      </div>
      {multiUser && (
        <CokluUserGirisYap
          girisYapilabilecekKullaniciListesi={userList}
          onClick={() => {
            setMultiUser(false);
          }}
        />
      )}
    </UserDropDwon>
  );

  const onFlagChangeHandle = (value, e) => {
    e.preventDefault();
    setState({
      ...state,
      flag: value,
    });
    i18n.changeLanguage(value);
  };

  const country = (
    <NavAuth>
      <Link onClick={(e) => onFlagChangeHandle('tr', e)} to="#">
        <img src={require('../../../static/img/flag/tr.png')} alt="" />
        <span>Türkçe</span>
      </Link>
      <Link onClick={(e) => onFlagChangeHandle('en', e)} to="#">
        <img src={require('../../../static/img/flag/en.png')} alt="" />
        <span>English</span>
      </Link>
    </NavAuth>
  );
  return (
    <InfoWraper>
      <div
        className="ninjadash-nav-actions__item ninjadash-nav-actions__author"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {!userDetail &&
          (Object.keys(muhendisData).length > 0 ||
            Object.keys(firmaData).length > 0 ||
            Object.keys(kurumData).length > 0) && (
            <>
              <Link to="/admin" style={{ marginRight: '25px' }}>
                <HomeFilled
                  style={{
                    transform: 'scale(1.2)',
                    transformOrigin: 'center',
                    cursor: 'pointer',
                    color: '#7d7d7d',
                  }}
                />
              </Link>
              <Popover placement="bottomRight" content={userContent} action="click">
                <Link to="#" className="ninjadash-nav-action-link" style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    style={{ backgroundColor: 'aliceblue' }}
                    icon={<UilUser />}
                    src={`${baseUrl}${profilePhoto}`}
                  />
                  <span className="ninjadash-nav-actions__author--name" title={profileFullUserName}>
                    {profileUserName}
                  </span>
                  <UilAngleDown />
                </Link>
              </Popover>
            </>
          )}
      </div>
    </InfoWraper>
  );
});

export default AuthInfo;
